export const actionTypes={
    FETCH_IS_SHOW_HEADER_FOOTER: 'FETCH_IS_SHOW_HEADER_FOOTER',
    FETCH_ENTERPRISE_SETTINGS: 'FETCH_ENTERPRISE_SETTINGS',
    FETCH_CUSTOM_MESSAGE_JSON_DATA: 'FETCH_CUSTOM_MESSAGE_JSON_DATA',
    IS_TOKEN_EXPIRED: "IS_TOKEN_EXPIRED",
    FETCH_NAVIGATE_DATA: "FETCH_NAVIGATE_DATA",
    SET_BASENAME: "SET_BASENAME",
    IS_ENTERPRISE_LISTING_PAGE: "IS_ENTERPRISE_LISTING_PAGE", 
    IS_CALL_FROM_BROWSER_BACK_EVENT: "IS_CALL_FROM_BROWSER_BACK_EVENT",
    SET_CURRENT_LOCATION: "SET_CURRENT_LOCATION",
    FETCH_EXTEND_NOTIFICATION_DETAIL: "FETCH_EXTEND_NOTIFICATION_DETAIL",
    SET_REFRESH_RECAPTCHA: "SET_REFRESH_RECAPTCHA",
    SET_RECAPTCHA_TOKEN: "SET_RECAPTCHA_TOKEN",
    LOCAL_CUSTOM_MESSAGES_JSON_DATA: "LOCAL_CUSTOM_MESSAGES_JSON_DATA",
    SET_WIDGET_INFO: "SET_WIDGET_INFO",
    SET_FIREBASE_TOKEN: "SET_FIREBASE_TOKEN",
    SET_SHOW_APP_RATING_BAR: "SET_SHOW_APP_RATING_BAR",
    SET_EMBED_DISPLAY_SETTINGS: "SET_EMBED_DISPLAY_SETTINGS",
    SET_IS_CALL_FROM_EMBED: "SET_IS_CALL_FROM_EMBED"
}